import { API_ROUTES } from '../constants/api'
import {
  GEOCODE,
  type LocationSelection,
  type LocationSuggestion,
} from '../constants/location'
import { api } from './api-client'

function str(value: unknown, fallback = ''): string {
  return value == null ? fallback : String(value)
}

function num(value: unknown): number | null {
  const parsed = Number(value)
  return Number.isFinite(parsed) ? parsed : null
}

function mapSuggestion(raw: Record<string, unknown>): LocationSuggestion | null {
  const lat = num(raw.lat)
  const lng = num(raw.lng)
  const label = str(raw.label).trim()
  if (lat == null || lng == null || !label) return null
  return {
    label,
    city: str(raw.city, label),
    lat,
    lng,
  }
}

export async function searchLocations(query: string): Promise<LocationSuggestion[]> {
  const normalized = query.trim()
  if (normalized.length < GEOCODE.minQueryLength) return []

  const params = new URLSearchParams({
    q: normalized,
    limit: String(GEOCODE.searchLimit),
  })
  const rows = await api.get<unknown>(`${API_ROUTES.locationSearch}?${params}`)
  if (!Array.isArray(rows)) return []
  return rows
    .map((item) => mapSuggestion(item as Record<string, unknown>))
    .filter((item): item is LocationSuggestion => item != null)
}

export function toLocationSelection(
  suggestion: LocationSuggestion,
): LocationSelection {
  const firstPart = suggestion.label.split(',')[0]?.trim()
  return {
    name: firstPart || suggestion.city,
    address: suggestion.label,
    latitude: suggestion.lat,
    longitude: suggestion.lng,
  }
}
